import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Get All Blog Categories
export const retrieveAllBlogCategories = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/blog/category/retrieve-all`,
        params,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)

// Create Blog Category
export const createBlogCategory = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/blog/category/create`,
        data,
        headers: headers()
      },
      thunkAPI,
      {
        successMsg: "Blog category created successfully!"
      }
    )
)

// Delete Blog Category
export const deleteBlogCategory = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        url: `${BASEURI}/admin/blog/category/delete/${id}`,
        headers: headers()
      },
      thunkAPI
    )
)

// Retrieve Single Blog Category
export const retrieveBlogCategory = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/blog/category/retrieve/${id}`,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
)

// Update Blog Category
export const updateBlogCategory = createAsyncThunk(
  "update",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/blog/category/update/${data?.categoryId}`,
        data: data?.formData,
        headers: headers()
      },
      thunkAPI
    )
)

// Create Blog
export const createBlog = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/blog/create`,
        data,
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        }
      },
      thunkAPI
    )
)

// Get All Blogs
export const retrieveAllBlogs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      status: data?.status || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/blog/retrieve-all`,
        params,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)

// Delete Blog
export const deleteBlog = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        url: `${BASEURI}/admin/blog/delete/${id}`,
        headers: headers()
      },
      thunkAPI
    )
)

// Retrieve Single Blog
export const retrieveBlog = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/blog/retrieve/${id}`,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
)

// Update Blog
export const updateBlog = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        url: `${BASEURI}/admin/blog/update/${data?.id}`,
        data: data?.formData,
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        }
      },
      thunkAPI
    )
  }
)